export default function YouTube({ id, width = "560", height = "315" }) {
  return (
    <div>
      <iframe
        title="YouTube video player"
        width={width}
        height={height}
        src={`https://www.youtube.com/embed/${id}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe>
    </div>
  );
}
